import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "is-flex is-justify-content-space-between has-background-white-ter mb-1 p-1 is-align-items-center" }
const _hoisted_2 = { class: "is-flex is-align-items-center mr-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon fas fa-file-alt is-small" }, null, -1)
const _hoisted_4 = { class: "ml-1" }
const _hoisted_5 = ["href", "download"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon fas fa-download is-small" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

import { OrderAttachmentType } from "@/interfaces/global/attachments"
type Props = {
  attachment: OrderAttachmentType
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderAttachmentDownload',
  props: {
    attachment: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("article", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.attachment.fileName), 1)
    ]),
    _createElementVNode("a", {
      href: _ctx.attachment.contentUrl,
      download: _ctx.attachment.fileName,
      class: "has-text-dark"
    }, _hoisted_7, 8, _hoisted_5)
  ]))
}
}

})